export default __webpack_public_path__ + "static/media/clock.4a4a634f.svg";